// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab___tab___2LuVy","active":"Tab___active___29d5G"};